import axios from 'axios'

import { createHttpClient, handlerError } from '@/utils/http-util'
import { connectSocket, disconnectSocket } from '@/utils/web-socket'

import environment from '../environment'
import store from '../store'

// eslint-disable-next-line no-unused-vars
function getBasicClient() {
  const client = axios.create()

  client.interceptors.request.use(async (config) => {
    config.headers['X-Forwarded-For'] = store.state.ip
    return config
  })

  return client
}

const EtaClient = getBasicClient()
EtaClient.defaults.baseURL = environment.ETA_URL
EtaClient.defaults.headers.post['Content-Type'] = 'application/json'
EtaClient.defaults.headers.put['Content-Type'] = 'application/json'
EtaClient.defaults.headers.delete['Content-Type'] = 'application/json'

EtaClient.interceptors.request.use(
  async (config) => {
    if (
      !config.url.endsWith('login') &&
      !config.url.endsWith('refresh') &&
      !config.url.endsWith('signup')
    ) {
      const userToken = await http.auth.updateRefreshToken()

      config.headers.Authorization = `Bearer ${userToken}`
    }

    return config
  },
  (error) => {
    // I cand handle a request with errors here
    return Promise.reject(error)
  }
)

const FlowClient = getBasicClient()
FlowClient.defaults.baseURL = environment.API_URL
FlowClient.defaults.headers.post['Content-Type'] = 'application/json'
FlowClient.defaults.headers.put['Content-Type'] = 'application/json'
FlowClient.defaults.headers.delete['Content-Type'] = 'application/json'

FlowClient.interceptors.request.use(
  async (config) => {
    if (
      !config.url.endsWith('login') &&
      !config.url.endsWith('refresh') &&
      !config.url.endsWith('signup')
    ) {
      const userToken = await http.auth.updateRefreshToken()

      config.headers.Authorization = `Bearer ${userToken}`
    }

    return config
  },
  (error) => {
    // I cand handle a request with errors here
    return Promise.reject(error)
  }
)

const AuthClient = getBasicClient()
AuthClient.defaults.baseURL = environment.API_URL

const http = {
  ...createHttpClient(FlowClient),
  eta: createHttpClient(EtaClient, (e) => e.data),
  async getIp() {
    return await axios
      .create()
      .get('https://api.ipify.org?format=json')
      .then((response) => {
        return response.data.ip
      })
  },
  auth: {
    async login({ email, password }) {
      try {
        const result = await AuthClient.post('accounts/login', {
          email,
          password,
        })

        if (!result) {
          return false
        }

        await store.dispatch('login', result.data.data)
        connectSocket()

        return true
      } catch (e) {
        handlerError(e)
        return false
      }
    },
    async logout() {
      await store.dispatch('logout')

      disconnectSocket()
    },
    async updateRefreshToken() {
      try {
        const userTokenExpiration = new Date(
          store.state.auth.userToken.expiration
        )
        userTokenExpiration.setMinutes(userTokenExpiration.getMinutes() - 1)

        const today = new Date()

        if (today > userTokenExpiration) {
          const refreshToken = store.state.auth.userToken.refreshToken

          const {
            data: { data },
          } = await FlowClient.post('accounts/refresh', {
            refreshToken,
          })

          await store.commit('login', data)

          return data.userToken.token
        } else {
          return store.state.auth.userToken.token
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
}

export default http
